import { FETCH_TAGS, LOGOUT } from '../actions/actionTypes.js';
// import { findIndex } from 'lodash';


const initialState = []

export const tags = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_TAGS.SUCCESS:
      return (action.payload.tags) || initialState//keyBy(action.payload.data['links'] || [], 'id');
    case FETCH_TAGS.UNLOAD:
      return [];
    case LOGOUT:
      return initialState;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/tags.js